import React, { Component } from 'react';


class Header extends Component {
   render() {

      if (this.props.data) {
         var name = this.props.data.name;
         var occupation = this.props.data.occupation;
         var description = this.props.data.description;
         var city = this.props.data.address.city;
         var networks = this.props.data.social.map(function (network) {
            return <li key={network.name}><a href={network.url} target="_blank"><i className={network.className}></i></a></li>
         })



         var name = this.props.data.name;
         var profilepic = "images/" + this.props.data.image;
         var bio = this.props.data.bio;
         var biop1 = this.props.data.biop1;
         var biop2 = this.props.data.biop2;
         var biop3 = this.props.data.biop3;
         var street = this.props.data.address.street;
         var city = this.props.data.address.city;
         var state = this.props.data.address.state;
         var zip = this.props.data.address.zip;
         var phone = this.props.data.phone;
         var email = this.props.data.email;
         var resumeDownload = this.props.data.resumedownload;
      }

      return (
         <header id="home">

            <nav id="nav-wrap">

               <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
               <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

               <ul id="nav" className="nav">
                  <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
                  {/* <li><a className="smoothscroll" href="#about">About</a></li> */}
                  <li><a className="smoothscroll" href="#portfolio">Projects</a></li>
                  <li><a className="smoothscroll" href="#resume">Resume</a></li>
                  <li><a className="smoothscroll" href="#testimonials">Testimonials</a></li>
                  <li><a className="smoothscroll" href="#contact">Contact</a></li>
               </ul>

            </nav>

            <div className="row banner">
               <ul className="social">
                  {networks}
               </ul>
               <div className="banner-text">

                  <section id="sid-section">
                     <div className="row">
                        <div className="four columns">
                        </div>

                        <h2 className="eight columns">Hello ! I am Siddharth Munupatrula.</h2>
                     </div>

                     <div className="row">
                        <div className="four columns col-sm-12 col-md-12 col-xs-12 main-col">
                           <img className="profile-pic" src={profilepic} alt="Siddharth Munupatrula Profile Pic" />
                        </div>
                        <div className="bios eight columns">
                           {/* <h2>Hello ! I am Siddharth Munupatrula.</h2> */}

                           {/* <p>{bio}</p> */}
                           <p>{biop1}</p>
                           <p>{biop2}</p>
                           <p>{biop3}</p>
                           {/* <div className="row"> */}
                           {/* <div className="columns contact-details"> */}
                           {/* <h2>Contact Details</h2> */}
                           {/* <p className="address"> */}
                           {/* <h3>{name}</h3> */}
                           {/* <br /> */}
                           {/* <span> */}
                           {/* {street}
                              <br /> */}
                           {/* {city}, {state} */}
                           {/* {zip} */}
                           {/* </span><br /> */}
                           {/* <span>{phone}</span><br /> */}
                           {/* <span>{email}</span> */}
                           {/* </p> */}
                           {/* </div> */}
                           {/* <div className="columns download"> */}
                           {/* <p> */}
                           {/* <a href={resumeDownload} className="button"><i className="fa fa-download"></i>Download Resume</a> */}
                           {/* </p> */}
                           {/* </div> */}
                           {/* </div> */}
                        </div>
                     </div>


                     {/* <h1 className="responsive-headline">Hi! I'm {name}.</h1> */}
                     {/* <h3>I haven't settled on a single identity yet.</h3> */}
                     {/* <h3> Let's look at the things I am pondering/exploring.</h3> */}
                     {/* <h3>I'm a {city} based <span>{occupation}</span>. {description}.</h3> */}
                     {/* <hr /> */}
                  </section>

               </div>


            </div>
            <div className="row banner">

               <p className="scrolldown">
                  <a className="smoothscroll" href="#portfolio"><i className="icon-down-circle"></i></a>
               </p>
            </div>

         </header >
      );
   }
}

export default Header;
